import { useSyncExternalStore } from "react";
import { applyUpdate, isUpdateReady, subscribeToUpdates } from "./register";

/**
 * The update prompt as a hook: needRefresh is true while a newer version of the app waits, applyUpdate
 * activates it and reloads. The shell shows it with design-system classes (features/shell/UpdateNotice.tsx);
 * L4-30 adds the offline and installed states around it.
 */
export function useUpdatePrompt(): { needRefresh: boolean; applyUpdate: () => void } {
  const needRefresh = useSyncExternalStore(subscribeToUpdates, isUpdateReady, () => false);
  return { needRefresh, applyUpdate };
}
